export function agruparEntradas(_data: any[]) {
    const agrupado = new Map();

    for (const item of _data) {
        const chave = [item.plid, item.cultid].join('|');

        if (!agrupado.has(chave)) {
            agrupado.set(chave, {
                plid: item.plid,
                pldescricao: item.pldescricao,
                plarea: item.plarea,
                pltipo: item.pltipo,
                cultid: item.cultid,
                cultdescricao: item.cultdescricao,
                totalembalagem: 0,
                totalpesagem: 0,
                pesagemarea: 0,
                embalagemarea: 0
            });
        }

        const grupo = agrupado.get(chave);
        grupo.totalembalagem += item.totalembalagem ?? 0;
        grupo.totalpesagem += item.totalpesagem ?? 0;
        grupo.pesagemarea += item.pesagemarea ?? 0;
        grupo.embalagemarea += item.embalagemarea ?? 0;
    }

    return Array.from(agrupado.values());
}

export function agruparClassificacoes(_data: any[]) {
    const agrupado = new Map();

    for (const item of _data) {
        const chave = [item.plid, item.cultid, item.culttamdescricao, item.culttamsequencia, item.culttamaproveitavel].join('|');

        if (!agrupado.has(chave)) {
            agrupado.set(chave, {
                plid: item.plid,
                pldescricao: item.pldescricao,
                cultid: item.cultid,
                cultdescricao: item.cultdescricao,
                culttamdescricao: item.culttamdescricao,
                culttamsequencia: item.culttamsequencia,
                culttamaproveitavel: item.culttamaproveitavel,
                totalembalagem: 0,
                totalpesagem: 0
            });
        }

        const grupo = agrupado.get(chave);
        grupo.totalembalagem += item.totalembalagem ?? 0;
        grupo.totalpesagem += item.totalpesagem ?? 0;
    }

    return Array.from(agrupado.values());
}

export function agruparSaidas(_data: any[]) {
    const agrupado = new Map<string, any>();

    for (const item of _data) {
        const chave = [item.plid, item.cultid, item.culttamdescricao, item.cultcatdescricao, item.culttamsequencia, item.prodidsaida].join('|');

        if (!agrupado.has(chave)) {
            agrupado.set(chave, {
                plid: item.plid,
                pldescricao: item.pldescricao,
                plarea: item.plarea,
                culttamdescricao: item.culttamdescricao,
                cultcatdescricao: item.cultcatdescricao,
                culttamsequencia: item.culttamsequencia,
                prodidsaida: item.prodidsaida,
                cultid: item.cultid,
                cultdescricao: item.cultdescricao,
                totalembalagem: 0,
                totalpesagem: 0,
                embalagemarea: 0,
                pesagemarea: 0,
            });
        }

        const grupo = agrupado.get(chave);

        const embalagem = Math.abs(item.totalembalagem ?? 0);
        const pesagem = Math.abs(item.totalpesagem ?? 0);

        grupo.totalembalagem += embalagem;
        grupo.totalpesagem += pesagem;

        grupo.embalagemarea = grupo.plarea ? grupo.totalembalagem / grupo.plarea : 0;
        grupo.pesagemarea = grupo.plarea ? grupo.totalpesagem / grupo.plarea : 0;
    }

    return Array.from(agrupado.values());
}